export default __webpack_public_path__ + "static/media/ico-no-dark.d333a545.svg";